import React from 'react';

import {
  cats,
  withShortcuts,
  WithShortcutsProps,
} from 'app/general/shortcuts/withShortcuts';
import {gt} from 'app/utils/i18n';

interface Props extends WithShortcutsProps {
  children: React.ReactElement;
  openVersions: () => unknown;
  openComments: () => unknown;
  openActivities: () => unknown;
  edit: () => unknown;
}

function BaseDetailPageSidebarShortcuts({
  enableShortcut,
  openVersions,
  openComments,
  edit,
  openActivities,
  children,
}: Props) {
  React.useEffect(() => {
    enableShortcut('v', openVersions);
    enableShortcut('c', openComments);
    enableShortcut('a', openActivities);
    enableShortcut('e', edit);
  }, []);

  return children;
}

export const DetailPageSidebarShortcuts = withShortcuts<Props>([
  {
    key: 'v',
    name: () => gt('Open versions sidebar'),
    category: cats.detailPage,
  },
  {
    key: 'c',
    name: () => gt('Open comments sidebar'),
    category: cats.detailPage,
  },
  {
    key: 'a',
    name: () => gt('Open activities sidebar'),
    category: cats.detailPage,
  },
  {
    key: 'e',
    name: () => gt('Edit'),
    category: cats.detailPage,
  },
])(BaseDetailPageSidebarShortcuts);
